"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridTable = exports.lockIcon = void 0;
exports.lockIcon = {
    width: '20px',
    height: '20px',
};
const gridTable = (palette) => ({
    alignItems: 'center',
    borderBottom: `1px solid ${palette.divider}`,
    display: 'grid',
    gridTemplateColumns: '1fr 50px 1.25fr 1.25fr repeat(2, 1fr) 40px 60px',
    gridColumnGap: '10px',
    gridRowGap: '10px',
    padding: '5px 0',
    '& div.lock-row': {
        display: 'grid',
        placeItems: 'center',
    },
    '& div.button-section': {
        justifySelf: 'end',
        display: 'flex',
        flexDirection: 'row',
    },
    '& #amount-header': {
        justifySelf: 'end',
    },
    '& #rules-header': {
        justifySelf: 'center',
    },
    '& #lock-header': {
        display: 'grid',
        placeItems: 'center',
    },
});
exports.gridTable = gridTable;
exports.default = ({ typography, spacing, palette }) => ({
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
        minWidth: 400,
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: 'auto',
        height: 'auto',
        marginRight: spacing(1),
        marginBottom: 4,
        color: palette.icon.secondary,
    },
    header: Object.assign({}, (0, exports.gridTable)(palette)),
    tdHeader: {
        display: 'flex',
        cursor: 'pointer',
    },
    lockIcon: Object.assign({}, exports.lockIcon),
    pageHeader: {
        marginBottom: spacing(2),
    },
    tableLoading: {
        width: '100%',
        minHeight: spacing(26),
        padding: `${spacing(2)} 0`,
        boxSizing: 'border-box',
        overflow: 'visible',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    spinnerWrapper: {
        width: 40,
        height: 40,
        position: 'relative',
    },
    spinnerActive: {
        color: palette.primary.main,
        position: 'absolute',
        top: 0,
        left: 0,
    },
    thFont: {
        fontWeight: typography.fontWeightMedium,
        color: palette.text.strong,
    },
    loadMoreContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(1),
        padding: spacing(2, 0, 3),
    },
    loadMoreSentinel: {
        height: 1,
        width: '100%',
    },
    loadMoreText: {
        color: palette.text.secondary,
    },
});
